var map = {
	"./cocon/cocon.woff": 26,
	"./cocon/cocon.woff2": 27,
	"./open-sans/open-sans-bold.eot": 28,
	"./open-sans/open-sans-bold.svg": 29,
	"./open-sans/open-sans-bold.ttf": 30,
	"./open-sans/open-sans-bold.woff": 31,
	"./open-sans/open-sans-bold.woff2": 32,
	"./open-sans/open-sans-regular.eot": 33,
	"./open-sans/open-sans-regular.svg": 34,
	"./open-sans/open-sans-regular.ttf": 35,
	"./open-sans/open-sans-regular.woff": 36,
	"./open-sans/open-sans-regular.woff2": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;